// extracted by mini-css-extract-plugin
export default {"returnToTop":"BackToTop_returnToTop__P2jVT","chevronUpIcon":"BackToTop_chevronUpIcon__eFBX4"};